import React, { useEffect, useState } from 'react';
import { Avatar, AvatarClassKey } from '@material-ui/core';
interface IUserAvatarProps {
  id: string;
  name: string;
  handleClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  backgroundColor: string;
  displayPointer?: boolean;
  height?: string;
  width?: string;
  src?: string;
  classes?: Partial<Record<AvatarClassKey, string>> | undefined;
}

const UserAvatarComp = ({
  id,
  name,
  handleClick,
  backgroundColor,
  displayPointer,
  height,
  width,
  src,
  classes,
}: IUserAvatarProps) => {
  const [displayFallback, setDisplayFallback] = useState(false);

  let useHeight = '2.5rem';
  let useWidth = '2.5rem';

  if (!!height) {
    useHeight = height;
  }
  if (!!width) {
    useWidth = width;
  }

  useEffect(() => {
    if (!!src) {
      setDisplayFallback(false);
    } else {
      setDisplayFallback(true);
    }
  }, [src]);

  return (
    <Avatar
      src={src}
      key={id}
      alt={`${name}`}
      style={
        !!displayPointer
          ? {
              backgroundColor: !!displayFallback ? backgroundColor : '#ffffff',
              cursor: 'pointer',
              height: useHeight,
              width: useWidth,
            }
          : {
              backgroundColor: !!displayFallback ? backgroundColor : '#ffffff',
              height: useHeight,
              width: useWidth,
            }
      }
      onClick={(e) => handleClick(e)}
      classes={!!classes ? classes : {}}
    >
      {!!displayFallback && name.substring(0, 1).toUpperCase()}
    </Avatar>
  );
};

// @ts-ignore
UserAvatarComp.whyDidYouRender = true;

export const UserAvatar = UserAvatarComp;
